import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { CurrencyConversionProfileModel } from 'lumen/routes/market/settings/currency-conversion/profile';
import { isErrorWithStatusCode } from 'lumen/utils/budget-forecast/data-fetching';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import SilentTaskError, {
  getErrorMessage,
} from 'lumen/utils/silent-task-error';

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  features: ['settings.exchange_rate_profiles.view'],
  redirectTo: 'hotel.settings',
})
export default class HotelSettingsCurrencyConversionProfileRoute extends Route {
  @service declare currencyConversion: Services['currency-conversion'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare router: Services['router'];

  model(params: { profile_id: string }): CurrencyConversionProfileModel {
    const model: CurrencyConversionProfileModel = {
      exchangeRatesProfile:
        this.currencyConversion.getExchangeRatesProfileByIdTask,
      baseCurrencies: this.currencyConversion.getBaseCurrenciesTask,
    };

    void this.performExchangeRatesProfile(params.profile_id);
    return model;
  }

  async performExchangeRatesProfile(profileId: string): Promise<void> {
    try {
      await this.currencyConversion.getExchangeRatesProfileByIdTask.perform(
        profileId,
      );
    } catch (error: unknown) {
      if (isErrorWithStatusCode(error) && error.status === 404) {
        this.router.transitionTo('hotel.settings.currency-conversion.index', {
          queryParams: { profileNotFound: true },
        });
        return;
      }
      this.errorTracking.captureException(error);
      throw new SilentTaskError(getErrorMessage(error));
    }
  }
}
